<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-09-16 16:59:51
 * @LastEditTime : 2020-01-12 11:10:41
 * @LastEditors  : Please set LastEditors
 -->
<template>
<div id="page_Container">
    <div id="main-container" class="main-container">
        <div id="withdrawalDetails">
            <div class="withdrawal-top">
                <div class="header">
                    <div class="one">
                        <div>可提现金额（元）</div>
                        <div class="explain rightdown" @click='ruleDescription'><van-icon name="question-o" />规则说明</div>
                    </div>
                    <div class="two">
                        <span>¥</span>
                        {{info.allowedDrawCash?info.allowedDrawCash:'0'}}
                    </div>
                    <div class="three">
                        <div class="tip" @click="toPage('OPWithdrawalRequest')">申请提现</div>
                        <div class="rightdown">即将到账（元）：{{info.waitAmount?info.waitAmount: '0'}}元</div>
                    </div>
                </div>
                <van-cell title="提现中" :value="info.drawingCash?'¥'+info.drawingCash:'￥0.00'" class="cell"/>
            </div>
            <div class="withdraw-container">
                <van-tabs v-model="active" swipeable @change="onChange">
                    <van-tab v-for="(title, index) in titles" :title="title.name" :key="index">
                        <!-- 内容 {{ title }} -->
                        <van-list
                            v-model="listLoading"
                            :finished="finished"
                            finished-text="没有更多了"
                            @load="onLoad()"
                            :offset="1"
                        >
                            <div class="priceRecord" v-for="(item, value) in data" :key="value">
                                <div class="title">
                                    <div class="use">{{item.type==='01'?'商品推广': item.type === '02'? '分销邀请':item.type === '03'? '提现': '提现失败退款'}}<span v-show="active === 3">{{item.withdrawalBankName+'  '}}{{item.withdrawalBankNo | desensitization}}</span></div>
                                    <div class="price"> {{getSign(item.type, active)}}¥{{item.amount? Number(item.amount).toFixed(2): '0.00'}}</div>
                                </div>
                                <div class="info">
                                    <div class="time">{{item.createTime}}</div>
                                    <div class="surplus">{{ (active=== 1|| active=== 2)?'':'余额：¥'+(item.balanceAmount?Number(item.balanceAmount).toFixed(2): '0.00') }}</div>
                                    <!-- <div class="surplus"></div> -->
                                </div>
                            </div>
                        </van-list>

                    </van-tab>
                </van-tabs>
            </div>
            <van-popup v-model="ruleShow" class='rulePopup'>
                <h5>分销规则</h5>
                <p>1.最低提现额度：最低提现额度为{{withdrawalCashLimit}}元即余额大于等于{{withdrawalCashLimit}}元方可提现。<br>
                    2.提现到账时间：提现成功后一般将在1-3个工作日到账，周末及法定节假日顺延。如逾期未到账，请查询银行卡出入账明细和分销中心提现余额是否有退回。<br>
                    3.为保障您的财产安全建议提现使用本人银行卡且认真填写完整账号与开户行（开户行不清楚可咨询银行客服）。<br>
                    4.如在提现过程中有任何疑问，请致电客服：400-666-5727。</p>
                <div>
                    <a href="javascript:void(0);" @click='ruleShow = false'>我知道了</a>
                </div>
            </van-popup>
        </div>
    </div>
</div>
</template>

<script>
import {
    toastLoading,
    clearToastLoading
} from '@/utils/base/utils';
import {
    mapGetters
} from 'vuex';
export default {
    data() {
        return {
            titles: [{
                name: '已到账',
                index: 2
            }, {
                name: '即将到账',
                index: 1
            }, {
                name: '已失效',
                index: 6
            }, {
                name: '提现记录',
                index: 5
            }],
            data: [],
            withdrawalCashLimit: 50,
            pageNum: 1,
            finished: false,
            loading: false,
            listLoading: false,
            // index: 0,
            info: {},
            active: 0,
            ruleShow: false
        };
    },
    esvReady() {
        // this.queryDistributionRecordPage(this.index);
        // this.queryAccountAmountInfo(2);
    },
    esvShow() {
        this.pageNum = 1;
        this.data = [];
        this.queryDistributionRecordPage(this.active);
        this.queryAccountWithdrawalCashRecord();
        this.queryAccountAmountInfo(2);
    },
    methods: {
        getSign(type, active = 0) {
            console.log(type, active);
            if (active === 3) {
                if (type === '03') {
                    return '-';
                } else {
                    return '+';
                }
            }
            return '';
        },
        onClick() {
            this.$toast('hi');
            console.log('hi');
        },
        onLoad(index) {
            console.log('load');

            this.pageNum += 1;
            this.listLoading = true;
            this.$nextTick(() => {
                this.queryDistributionRecordPage(this.active);
            });

            // console.log(this.index);
        },
        onChange(index, title) {
            // this.index = index;
            this.pageNum = 1;
            // alert(this.pageNum);

            this.listLoading = true;
            this.finished = false;

            this.data = [];
            // console.log(this.index);
            this.queryDistributionRecordPage(index);
            this.queryAccountAmountInfo(2);
        },
        trueIndex(index) {
            const ths = this;
            for (let i = 0; i < ths.titles.length; i++) {
                const item = ths.titles[i];
                if (i === index) {
                    return item.index;
                }
            }
        },
        toPage(name) {
            console.log(name);

            this.esvOpenPage(name);
        },
        queryAccountAmountInfo(status) {
            const ths = this;
            this.$doRequest({
                url: '/account/queryAccountAmountInfo',
                params: {
                    status,
                    merchantInfo: JSON.stringify(this.merchantInfoSwitch)
                },
                before: function () {
                    ths.loading = toastLoading();
                },
                complete: function () {
                    clearToastLoading(ths.loading);
                }
            },
            function (data) {
                ths.info = {
                    ...data.result
                };
                for (const key in ths.info) {
                    if (ths.info.hasOwnProperty(key)) {
                        const item = ths.info[key];
                        ths.info[key] = Number(item).toFixed(2);
                    }
                }
            }
            );
        },
        queryAccountWithdrawalCashRecord() {
            const ths = this;
            this.$doRequest(
                {
                    url: '/account/queryAccountWithdrawalCashRecord',
                    params: { merchantInfo: JSON.stringify(this.merchantInfoSwitch) },
                    before: function() {
                        ths.loading = toastLoading();
                    },
                    complete: function() {
                        clearToastLoading(ths.loading);
                    }
                },
                function (data) {
                    ths.withdrawalCashLimit = data.result.withdrawalCashLimit;
                }
            );
        },
        queryDistributionRecordPage(status) {
            // status += 1;
            const ths = this;
            status = this.trueIndex(status);
            this.$doRequest({
                url: '/account/queryDistributionRecordPage',
                params: {
                    status,
                    pageNum: this.pageNum,
                    merchantInfo: JSON.stringify(this.merchantInfoSwitch)
                },
                before: function () {
                    ths.loading = toastLoading();
                },
                complete: function () {
                    clearToastLoading(ths.loading);
                    ths.finished = true;
                }
            },
            function (data) {
                ths.listLoading = false;
                // data.result.list.every(item => {
                //     if (item.withdrawalBankNo) {
                //         let withdrawalBankNo = item.withdrawalBankNo;
                //         item.withdrawalBankNo = withdrawalBankNo.replace(/^(.{4})(?:\d+)(.{4})$/, '$1******$2');
                //         return true;
                //     } else {
                //         return false;
                //     }
                // });
                ths.data = [...ths.data, ...data.result.list];
                if (ths.data.length < data.result.total) {
                    ths.finished = false;
                } else {
                    ths.finished = true;
                }
            }
            );
        },

        // 点击规则说明弹出框
        ruleDescription() {
            this.ruleShow = true;
        }
    },
    filters: {
        desensitization: function (value) {
            console.log(value);

            if (value) {
                return value.replace(/^(.{4})(?:\d+)(.{4})$/, '$1******$2');
            }
            return '';
        }
    },
    computed: {
        ...mapGetters([
            'merchantInfoSwitch'
        ])
    }
};
</script>

<style lang="scss">
    #withdrawalDetails {
        height: 100%;
        // padding-top: 180px;
        // overflow: hidden;
        .withdrawal-top {
            height: 180px;
            .header {
                background-image: linear-gradient(-180deg, #EF4274 0%, #EE3556 100%);
                color: #fff;
                width: 100%;

                padding: 10px 14px 10px 30px;
            }
            // position: absolute;
            // top: 0;
            .one {
                position: relative;
                justify-content: space-between;
                font-size: 14px;
                margin-bottom: 8px;

                .explain {

                    font-size: 10px;
                }
            }

            .two {
                font-size: 23px;
                position: relative;
                padding-left: 14px;
                margin-bottom: 8px;

                span {
                    left: -3px;
                    bottom: 0;
                    font-size: 18px;
                    position: absolute;
                    // line-height: 10px;
                    display: block;
                }
            }

            .three {
                justify-content: space-between;
                font-size: 12px;
                position: relative;

                .tip {
                    font-size: 14px;
                    border: 1px solid #fff;
                    border-radius: 12.5px;
                    padding: 0 5px;
                    width: 70px;
                    height: 24px;
                    line-height: 24px;
                }
            }
        }

        .rightdown {
            position: absolute;
            bottom: 0;
            right: 0;
        }

        .cell {
            // top: 10px;
            height: 50px;
            // margin-bottom: 10px;
            .van-cell__value {
                font-size: 14px;
                color: black !important;
            }
        }

        .priceRecord {
            background-color: #fff;
            padding: 12px 14px;

            >div {
                display: flex;
                justify-content: space-between;
            }

            .title {
                font-size: 14px;

                span {
                    color: #BEBEC5;
                    padding-left: 8px;
                }
            }

            .info {
                font-size: 12px;
                color: #BEBEC5;
            }
        }

        .withdraw-container {
            height: calc(100% - 180px);

            // height: 100%;
            // width: 100%;
            // overflow: auto;
            // overflow: hidden;
            // position: relative;
            // height: calc(100% - 300px);
            .van-tabs--line {
                height: 100%;
            }

            .van-tabs__content .van-tab__pane {
                overflow: auto;
            }
        }
        .rulePopup {
            width: 270px;
            height: 400px;
            padding: 16px 12px;

            h5 {
                font-size: 18px;
                text-align: center;
                font-weight: 500;
            }

            p {
                margin: 16px 0;
                font-size: 14px;
                color: #999;
                max-height: 275px;
                overflow: auto;
            }

            div {
                text-align: center;
                position: absolute;
                width: 100%;
                bottom: 16px;
                left: 0;

                a {
                    color: #EE2E50;
                    font-size: 16px;
                }
            }
        }
    }

</style>
